import devtoolsPlugin from '@backstage/plugin-devtools/alpha';

/** Custom DevTools layout and tabs; permission guard lives in CustomDevToolsPage. */
const devtoolsFeature = devtoolsPlugin.withOverrides({
  extensions: [
    devtoolsPlugin.getExtension('page:devtools').override({
      factory(originalFactory) {
        return originalFactory({
          params: {
            path: '/devtools',
            noHeader: true,
            loader: async () => {
              const { CustomDevToolsPage } = await import(
                '../components/devtools/CustomDevToolsPage'
              );
              return <CustomDevToolsPage />;
            },
          },
        });
      },
    }),
  ],
});

export default devtoolsFeature;
